/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 8
// module chunks = main